import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as mangerAip from "../../api/managerApi/managerApi";
import {EQUser, initializeUser} from "../../models/serverModels/EQUser";
import {yupResolver} from "@hookform/resolvers/yup";
import {userSchema} from "../../validation/userSchema";
import ManagerForm from "./ManagerForm";

const CreateManager = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQUser>,
    Params.Create<EQUser>
  >({
    api: mangerAip.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Manager`);
        queryClient.invalidateQueries("ManagerList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQUser>({
    defaultValues: initializeUser(3),
    resolver: yupResolver(userSchema),
  });

  const onSubmit: SubmitHandler<EQUser> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeUser(3), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="업체 담당자 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <ManagerForm companyDisabled={false} />
          <ConfirmButtonGroup link={`/Manager`} cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateManager;
